import { useNavigate } from "react-router-dom";
import { Heart, MapPin, BadgeCheck } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import api, { fileUrl, formatIDR } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const condColor = {
  "Seperti Baru": "bg-emerald-50 text-emerald-700",
  "Sangat Baik": "bg-sky-50 text-sky-700",
  "Baik": "bg-amber-50 text-amber-700",
  "Cukup": "bg-gray-100 text-gray-600",
};

export default function ProductCard({ product, index = 0 }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [liked, setLiked] = useState(product.liked);
  const [count, setCount] = useState(product.likes_count);

  const toggleLike = async (e) => {
    e.stopPropagation();
    if (!user) {
      navigate("/login");
      return;
    }
    try {
      const { data } = await api.post(`/products/${product.id}/like`);
      setLiked(data.liked);
      setCount(data.likes_count);
      toast.success(data.liked ? "Ditambahkan ke suka" : "Dihapus dari suka");
    } catch {
      toast.error("Gagal menyukai produk");
    }
  };

  return (
    <div
      data-testid={`product-card-${product.id}`}
      onClick={() => navigate(`/product/${product.id}`)}
      className="bg-white rounded-2xl overflow-hidden border border-gray-100 card-hover cursor-pointer fade-up"
      style={{ animationDelay: `${Math.min(index * 40, 400)}ms` }}
    >
      <div className="relative aspect-square bg-gray-100 overflow-hidden">
        <img src={fileUrl((product.images || [])[0])} alt={product.title} className="w-full h-full object-cover" loading="lazy" />
        {product.status === "sold" && (
          <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
            <span className="bg-white text-[#0B4DA2] font-bold px-3 py-1 rounded-full text-xs">TERJUAL</span>
          </div>
        )}
        <button
          data-testid={`product-like-button-${product.id}`}
          onClick={toggleLike}
          className="absolute top-2 right-2 w-8 h-8 rounded-full bg-white/90 backdrop-blur flex items-center justify-center shadow"
        >
          <Heart className={`w-4 h-4 ${liked ? "fill-[#E0533C] text-[#E0533C]" : "text-gray-500"}`} />
        </button>
      </div>
      <div className="p-3">
        <div className="text-[#0B4DA2] font-extrabold text-sm sm:text-base">{formatIDR(product.price)}</div>
        <div className="text-xs sm:text-sm text-gray-700 line-clamp-2 mt-0.5 min-h-[2.2em]">{product.title}</div>
        <div className="mt-2 flex items-center justify-between">
          <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${condColor[product.condition] || "bg-gray-100 text-gray-600"}`}>
            {product.condition}
          </span>
          {count > 0 && (
            <span className="text-[10px] text-gray-400 flex items-center gap-0.5">
              <Heart className="w-3 h-3" /> {count}
            </span>
          )}
        </div>
        <div className="mt-2 flex items-center gap-1 text-[11px] text-gray-400">
          <MapPin className="w-3 h-3" /> {product.location}
          {product.seller?.verified && <BadgeCheck className="w-3 h-3 text-[#0B4DA2] ml-auto" />}
        </div>
      </div>
    </div>
  );
}
